import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  DOCUMENT,
} from '@angular/core';
import { JsonConverterService } from '@app/core/services/json-converter.service';

declare var Two: any;

@Component({
  selector: 'ecp-frametrace-visualizer',
  templateUrl: './frame-tracer.component.html',
  styleUrls: ['./frame-tracer.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false,
})
export class FrameTracerComponent implements OnInit {
  @ViewChild('previewModalBody') $body: ElementRef;
  @Input() fileData: any;
  number_of_points;
  new_points_array = [];
  num_points;
  title = 'eoa-frametrace-visualizer';
  file: File;
  frameJson: any;
  trace_count: any;
  data: any;
  firstEye_data: any;
  secondEye_data: any;
  showFrameTraceUpload = true;
  private container: ViewContainerRef;
  private scale: number;
  private two: any;
  private leftEye: any;
  private rightEye: any;
  private dblBox: any;
  private changed: boolean;
  private newPoints: any;
  private a: any;
  private b: any;
  private c: any;
  private dbl: any;
  private ed: any;
  private originalA: any;
  private originalB: any;
  private originalC: any;
  private originalDBL: any;
  private originalED: any;
  private line: number = +Two.Commands.line;
  files: any = [];

  constructor(
    private jsonConverterService: JsonConverterService,
    private element: ElementRef,
    private viewContainer: ViewContainerRef,
    @Inject(DOCUMENT) document,
    private renderer: Renderer2,
  ) {
    setTimeout(() => {
      this.initializeValues();
    }, 0);
  }

  ngOnInit() {
    if (this.fileData) {
      this.showFrameTraceUpload = false;
      this.file = this.fileData;
      this.uploadDocument();
    }
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes.fileData) {
  //     console.log('changes' + this.fileData);
  //     this.showFrameTraceUpload = false;
  //     console.log(this.fileData);
  //     this.file = this.fileData;
  //     this.uploadDocument();
  //   }
  // }

  deleteAttachment(index) {
    this.files.splice(index, 1);
  }

  initializeValues() {
    this.container = this.viewContainer;
    this.two = new Two();
    const twwo = this.two;
    this.two.style = 'border';
    this.two.width = this.setWidth();
    this.two.height = 375;
    this.two.appendTo(this.$body.nativeElement);
    this.renderer.addClass(this.$body.nativeElement, 'preview');
    let a = this.$body;
    this.scale = 3.582677165; // 91ppi
    const background = this.two.makeRectangle(this.two.width / 2, this.two.height / 2, this.two.width, this.two.height);
    background.fill = '#5fa4ff';
    this.leftEye = this.two.makePolygon();
    this.leftEye.linewidth = 0.2;
    this.leftEye._matrix.manual = true;
    this.leftEye.noFill();
    this.leftEye.boundingBox = this.two.makePolygon();
    this.leftEye.boundingBox.linewidth = 0.2;
    this.leftEye.boundingBox.noFill();
    this.leftEye.boundingBox.scale = this.scale;
    this.leftEye.boundingBox._matrix.manual = true;
    this.rightEye = this.two.makePolygon();
    this.rightEye.linewidth = 0.2;
    this.rightEye.noFill();
    this.rightEye._matrix.manual = true;
    this.rightEye.boundingBox = this.two.makePolygon();
    this.rightEye.boundingBox._matrix.manual = true;
    this.rightEye.boundingBox.linewidth = 0.2;
    this.rightEye.boundingBox.noFill();
    this.rightEye.boundingBox.scale = this.scale;
    this.dblBox = this.two.makePolygon();
    this.dblBox.scale = this.scale;
    this.dblBox.noFill();
    this.dblBox.linewidth = 0.2;
    this.dblBox.translation = new Two.Vector(this.two.width / 2, this.two.height / 2);
    this.changed = false;
    let self = this;
    this.two
      .bind('input', () => {
        if (self.changed) {
          self.changed = false;
          if (self.trace_count === 1 && self.data) {
            self.updateVertices(self.data);
          } else if (self.trace_count === 2 && self.firstEye_data && self.secondEye_data) {
            self.updateLeftVertices(self.firstEye_data);
            self.updateRightVertices(self.secondEye_data);
            self.updateDBLBox(self.firstEye_data);
          }
        }
      })
      .play();
  }

  draw() {
    if (this.frameJson.trace_count === 1) {
      // console.log("1 trace");
      this.setValues(
        {
          a: this.frameJson.framea,
          b: this.frameJson.frameb,
          c: this.frameJson.framecirc,
          ed: this.frameJson.frameed,
          dbl: this.frameJson.framedbl,
          trace_count: this.frameJson.trace_count,
          num_points: this.frameJson.first_num_points,
        },
        this.frameJson.framepoints.framepoints_items,
      );
      if (this.frameJson.first_eye_pos === 'L') {
        this.updateVerticesReverse(this.frameJson.framepoints.framepoints_items);
      } else {
        this.updateVertices(this.frameJson.framepoints.framepoints_items);
      }
    } else if (this.frameJson.trace_count === 2) {
      // console.log("2 traces");
      this.setValues(
        {
          a: this.frameJson.framea,
          b: this.frameJson.frameb,
          c: this.frameJson.framecirc,
          ed: this.frameJson.frameed,
          dbl: this.frameJson.framedbl,
          firstEye_data: this.frameJson.first_framepoints.framepoints_items,
          secondEye_data: this.frameJson.second_framepoints.framepoints_items,
          trace_count: this.frameJson.trace_count,
          num_points: this.frameJson.first_num_points,
        },
        this.frameJson.first_framepoints.framepoints_items,
      );
      this.updateLeftVertices(this.frameJson.second_framepoints.framepoints_items);
      this.updateRightVertices(this.frameJson.first_framepoints.framepoints_items);
      this.updateDBLBox(this.frameJson.first_framepoints.framepoints_items);
    }
  }

  fileChanged(e): void {
    this.showFrameTraceUpload = false;
    // console.log('e => ', JSON.stringify(e));
    // if (e.target) {
    //   console.log('e.target.files => ', JSON.stringify(e.target.files));
    // } else {
    //   console.log('e.target.files => ', JSON.stringify(e[0]));
    // }

    try {
      if (e.target) {
        // console.log(' e.target.files[0] => ', e.target.files[0]);
        this.file = e.target.files[0];
      } else {
        // console.log('e => ', e[0]);
        this.file = e[0];
      }
    } catch (e) {
      // console.log(' e.target.FileList[0] => ', e.target.FileList[0]);
      this.file = e.target.FileList[0];
    }
    this.uploadDocument();
  }

  uploadDocument(): void {
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const text: string = fileReader.result.toString();
      const fileName = this.file.name;
      this.frameJson = this.jsonConverterService.convertFile(text, fileName);
      // console.log(this.frameJson);
      this.draw();
    };
    fileReader.readAsText(this.file);
  }

  updateDBLBox(data): void {
    this.data = data;
    const vertices = this.createPlotData(data);
    const calcs = this.performCalcs(vertices);

    const center = calcs.center; // calculateGeometricCenter(vertices);
    const boundingBoxVertices = calcs.boundingBox; // createBoundingBox(vertices);
    const xOffset =
      (parseFloat(this.a) / 2) * this.scale + (parseFloat(this.dbl) / 2) * this.scale - center.x * this.scale;
    const yScale = ((data && data.angles) || []).length ? -1 : 1;
  }

  onRefreshButtonClick(): void {
    this.two.width = this.setWidth();
  }

  clear(): void {
    //this.data = 0;
    this.a = 0;
    this.b = 0;
    this.c = 0;
    this.dbl = 0;
    this.ed = 0;
    this.originalA = 0;
    this.originalB = 0;
    this.originalC = 0;
    this.originalDBL = 0;
    this.originalED = 0;
  }

  createPlotData(data, eye = 'both'): Array<any> {
    const radii = (data && data.radii) || data || [];
    const angles = (data && data.angles) || [];
    const arr = [];
    for (let i = 0; i < radii.length; i++) {
      const distance = parseFloat(radii[i].framepoint);
      const angle = this.calcAngle(angles, radii, i);
      // @ts-ignore
      const anchor = new Two.Anchor(this.calcX(distance, angle, i), this.calcY(distance, angle), Two.Commands.line);
      arr.push(anchor);
    }
    if (eye === 'left') {
      this.newPoints.left = arr;
    } else if (eye === 'right') {
      this.newPoints.right = arr;
    } else if (eye === 'both') {
      this.newPoints = arr;
    }
    return arr;
  }

  private setWidth(): number {
    return window.innerWidth / 2;
  }

  private calcAngle(angles, radii, index): number {
    if (angles.length) {
      return this.degToRad(angles[index]);
    } else {
      return this.degToRad((radii.length - index) * (360 / radii.length));
    }
  }

  private degToRad(deg): number {
    return (parseInt(deg, 10) * Math.PI) / 180;
  }

  private performCalcs(vertices): any {
    // console.log("performCalcs");
    // console.log(vertices);
    let minMax = this.calculateMinMax(vertices);
    minMax = this.divide(minMax);
    let maxDistance = 0;
    // tslint:disable-next-line:variable-name
    const maxDistance_old = 0;
    const center = {
      x: (minMax[0] + minMax[2]) / 2,
      y: (minMax[1] + minMax[3]) / 2,
    };

    this.new_points_array = [];
    // tslint:disable-next-line:variable-name
    const new_points_array_max = [];
    // tslint:disable-next-line:variable-name
    let new_x = 0;
    // tslint:disable-next-line:variable-name
    let new_y = 0;
    // tslint:disable-next-line:variable-name
    let new_framePoint = 0;
    for (const vertex of vertices) {
      new_x = parseFloat(vertex.x);
      new_y = parseFloat(vertex.y);
      new_framePoint = Math.sqrt(new_x * new_x + new_y * new_y);
      this.new_points_array.push(new_framePoint.toFixed(2));
      new_points_array_max.push(new_framePoint);
      maxDistance = Math.max(...new_points_array_max);
    }
    // console.log(new_points_array);
    // tslint:disable-next-line:one-variable-per-declaration
    let a, b, r1, r2;
    let circ = 0;
    const angle = (Math.PI * 2) / 400;
    for (let i = 1; i < this.new_points_array.length; i++) {
      r1 = parseFloat(this.new_points_array[i - 1]);
      r2 = parseFloat(this.new_points_array[i]);

      if (r1 > r2) {
        a = Math.sin(angle) * r2;
        b = r1 - Math.cos(angle) * r2;
      } else {
        a = Math.sin(angle) * r1;
        b = r2 - Math.cos(angle) * r1;
      }
      circ += Math.sqrt(a * a + b * b);
    }
    r1 = parseFloat(this.new_points_array[0]);
    r2 = parseFloat(this.new_points_array[this.new_points_array.length - 1]);
    if (r1 > r2) {
      a = Math.sin(angle) * r2;
      b = r1 - Math.cos(angle) * r2;
    } else {
      a = Math.sin(angle) * r1;
      b = r2 - Math.cos(angle) * r1;
    }
    circ += Math.sqrt(a * a + b * b);

    // @ts-ignore
    // @ts-ignore
    return {
      center,
      boundingBox: [
        new Two.Anchor(minMax[0], minMax[1], this.line, 0, 0, 0, null),
        new Two.Anchor(minMax[2], minMax[1], this.line, 0, 0, 0, null),
        new Two.Anchor(minMax[2], minMax[3], this.line, 0, 0, 0, null),
        new Two.Anchor(minMax[0], minMax[3], this.line, 0, 0, 0, null),
      ],
      ed: this.fixFloat(maxDistance * 2),
      circ,
      // circ: circ + distanceBetween(vertices[0], vertices[vertices.length - 1])
    };
  }

  private calcCircumference(data) {
    let lastPoint = data[0];
    let circ = 0;
    for (let i = 0; i < data.length; i += 1) {
      circ += this.distanceBetween(data[i], lastPoint);
      lastPoint = data[i];
    }
    return circ + this.distanceBetween(data[0], data[data.length - 1]);
  }

  private parseData(data) {
    return data.radii || data || [];
  }

  private createDBLBox(a, b, dbl) {
    let right = parseFloat(dbl) / 2;
    let left = -right;
    let top = b / 4;
    let bot = -top;
    return [
      new Two.Anchor(right, top, this.line, 0, 0, 0, null),
      new Two.Anchor(right, bot, this.line, 0, 0, 0, null),
      new Two.Anchor(left, bot, this.line, 0, 0, 0, null),
      new Two.Anchor(left, top, this.line, 0, 0, 0, null),
    ];
  }

  private calculateMinMax(data) {
    let minMax = [];
    for (let i = 0; i < data.length; i++) {
      if (minMax.length) {
        minMax[0] = Math.max(minMax[0], data[i].x);
        minMax[1] = Math.max(minMax[1], data[i].y);
        minMax[2] = Math.min(minMax[2], data[i].x);
        minMax[3] = Math.min(minMax[3], data[i].y);
      } else {
        minMax[0] = data[i].x;
        minMax[1] = data[i].y;
        minMax[2] = data[i].x;
        minMax[3] = data[i].y;
      }
    }
    return minMax;
  }

  private createBoundingBox(vertices) {
    let minMax = this.calculateMinMax(vertices);
    return [
      new Two.Anchor(minMax[0], minMax[1], this.line, 0, 0, 0, null),
      new Two.Anchor(minMax[2], minMax[1], this.line, 0, 0, 0, null),
      new Two.Anchor(minMax[2], minMax[3], this.line, 0, 0, 0, null),
      new Two.Anchor(minMax[0], minMax[3], this.line, 0, 0, 0, null),
    ];
  }

  private distanceBetween(a, b) {
    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
  }

  private fixFloat(f) {
    return (Math.round(f * 10) / 10).toFixed(2);
  }

  private filter(arr, comparator, byFn) {
    // console.log("filter");
    let tmp;
    arr.forEach((index, element) => {
      if (tmp === undefined) {
        tmp = byFn(element);
      } else {
        tmp = comparator(tmp, byFn(element));
      }
    });
    return tmp;
  }

  private maxBy(arr, fn) {
    return this.filter(arr, Math.max, fn);
  }

  private minBy(arr, fn) {
    return this.filter(arr, Math.min, fn);
  }

  private calculateGeometricCenter(data) {
    let minMax = this.calculateMinMax(data);
    return {
      x: (minMax[0] + minMax[2]) / 2,
      y: (minMax[1] + minMax[3]) / 2,
    };
  }

  private getED(vertices) {
    let maxDistance = 0;
    let distance_array = [];
    for (let x = 0; x < vertices.length; x++) {
      let new_x = parseFloat(vertices[x].x);
      let new_y = parseFloat(vertices[x].y);
      let new_framePoint = Math.sqrt(new_x * new_x + new_y * new_y);
      distance_array.push(new_framePoint);
      maxDistance = Math.max(...distance_array);
    }
    let ed = this.fixFloat(maxDistance * 2);
    return ed;
  }

  public setValues(values, data) {
    this.setA(values.a);
    this.setB(values.b);
    this.setDBL(values.dbl);
    this.setC(values.c);
    this.setfirstEye_data(values.firstEye_data);
    this.setsecondEye_data(values.secondEye_data);
    this.setTraceCount(values.trace_count);
    this.setNumPoints(values.num_points);
    this.setED(data);
  }

  private setA(a) {
    this.a = a;
    this.originalA = a;
  }

  private setB(b) {
    this.b = b;
    this.originalB = b;
  }

  private setC(c) {
    this.c = c;
    this.originalC = c;
  }

  private setDBL(dbl) {
    this.dbl = dbl;
    this.originalDBL = dbl;
  }

  private setED(data) {
    let vertices = this.createPlotData(data);
    let ed = this.getED(vertices);
    this.ed = ed;
    this.originalED = ed;
  }

  private setfirstEye_data(firstEye_data) {
    this.firstEye_data = firstEye_data;
  }

  private setsecondEye_data(secondEye_data) {
    this.secondEye_data = secondEye_data;
  }

  private setTraceCount(trace_count) {
    this.trace_count = trace_count;
  }

  private setNumPoints(num_points) {
    this.num_points = num_points;
    this.number_of_points = num_points;
  }

  private calcX(distance, angle, i) {
    return distance * Math.cos(angle) * this.xScale();
  }

  private calcY(distance, angle) {
    return distance * Math.sin(angle) * this.yScale();
  }

  private xScale() {
    return this.a / this.originalA || 1;
  }

  private yScale() {
    return this.b / this.originalB || 1;
  }

  private updateLeftVertices(data) {
    this.data = data;
    let vertices = this.createPlotData(data, 'left');
    let calcs = this.performCalcs(vertices);

    let center = calcs.center; //calculateGeometricCenter(vertices);
    let boundingBoxVertices = calcs.boundingBox; //createBoundingBox(vertices);
    let xOffset =
      (parseFloat(this.a) / 2) * this.scale + (parseFloat(this.dbl) / 2) * this.scale - center.x * this.scale;
    let yScale = ((data && data.angles) || []).length ? -1 : 1;

    this.leftEye.vertices = vertices;
    this.leftEye._matrix
      .identity()
      .translate(this.two.width / 2 + xOffset, this.two.height / 2 + center.y)
      .scale(-1 * this.scale, this.scale * yScale)
      //THIS IS NEEDED TO FLIP THE IMAGE BUT MAYBE ONLY NEEDED WHEN WE HAVE TWO TRACES IN A FILE????
      .scale(-1, 1);

    //This is for making a box around the lense.
    // this.rightEye.boundingBox.vertices = boundingBoxVertices;
    // this.rightEye.boundingBox._matrix.identity()
    // 																 .translate((this.two.width / 2) + xOffset, (this.two.height / 2) + center.y)
    // 																 .scale(this.scale, this.scale * yScale);

    //This is for making the box dashed.
    // if(this.rightEye.boundingBox._renderer.elem) {
    // 	this.rightEye.boundingBox._renderer.elem.setAttribute('stroke-dasharray', '2,2');
    // }

    let colors = [
      'rgb(255, 64, 64)',
      'rgb(255, 128, 0)',
      'rgb(0, 200, 255)',
      'rgb(0, 191, 168)',
      'rgb(153, 102, 255)',
      'rgb(255, 244, 95)',
    ];

    let grad = this.two.makeLinearGradient(
      10,
      10,
      -10,
      -10,
      new Two.Stop(0, colors[0], 0),
      new Two.Stop(1, colors[1], 0),
      new Two.Stop(1, colors[2], 0),
    );

    this.leftEye.fill = this.two.makeRadialGradient(
      10,
      -25,
      this.a * 2,
      new Two.Stop(0, 'rgb(255, 255, 255)', null),
      new Two.Stop(1, 'rgb(0,0,0)', null),
    );
  }

  private updateVertices = function (data) {
    this.data = data;
    let vertices = this.createPlotData(data, 'both');
    let calcs = this.performCalcs(vertices);

    let circ = calcs.circ.toFixed(2);
    this.c = circ;

    let center = calcs.center; //calculateGeometricCenter(vertices);
    let boundingBoxVertices = calcs.boundingBox; //createBoundingBox(vertices);
    let xOffset =
      (parseFloat(this.a) / 2) * this.scale + (parseFloat(this.dbl) / 2) * this.scale - center.x * this.scale;
    let yScale = ((data && data.angles) || []).length ? -1 : 1;

    this.leftEye.vertices = vertices;
    this.leftEye._matrix
      .identity()
      .translate(this.two.width / 2 + xOffset, this.two.height / 2 + center.y)
      .scale(-1 * this.scale, this.scale * yScale);

    // This is for adding a box around the lense.
    // this.leftEye.boundingBox.vertices = boundingBoxVertices;
    // this.leftEye.boundingBox._matrix.identity()
    // 																.translate((this.two.width / 2) - (xOffset), (this.two.height / 2) + center.y)
    // 																.scale(-1 * this.scale, this.scale * yScale);

    //This is for making the box a dashed line
    // if(this.leftEye.boundingBox._renderer.elem) {
    // this.leftEye.boundingBox._renderer.elem.setAttribute('stroke-dasharray', '2,2');
    // }

    this.rightEye.vertices = vertices;
    this.rightEye._matrix
      .identity()
      .translate(this.two.width / 2 - xOffset, this.two.height / 2 + center.y)
      .scale(this.scale, this.scale * yScale);

    // This is for adding a box around the lense.
    // this.rightEye.boundingBox.vertices = boundingBoxVertices;
    // this.rightEye.boundingBox._matrix.identity()
    // 																 .translate((this.two.width / 2) + xOffset, (this.two.height / 2) + center.y)
    // 																 .scale(this.scale, this.scale * yScale);

    //This is for making the box a dashed line
    // if(this.rightEye.boundingBox._renderer.elem) {
    // this.rightEye.boundingBox._renderer.elem.setAttribute('stroke-dasharray', '2,2');
    // }

    // This is for creating the DBL box
    // this.dblBox.vertices = createDBLBox(this.a, this.b, this.dbl);

    //This is for making the box a dashed line
    // if(this.dblBox._renderer.elem) {
    // this.dblBox._renderer.elem.setAttribute('stroke-dasharray', '2,2');
    // }

    let colors = [
      'rgb(255, 64, 64)',
      'rgb(255, 128, 0)',
      'rgb(0, 200, 255)',
      'rgb(0, 191, 168)',
      'rgb(153, 102, 255)',
      'rgb(255, 244, 95)',
    ];
    let grad = this.two.makeLinearGradient(
      10,
      10,
      -10,
      -10,
      new Two.Stop(0, colors[0], 0),
      new Two.Stop(1, colors[1], 0),
      new Two.Stop(1, colors[2], 0),
    );
    this.leftEye.fill = this.two.makeRadialGradient(
      10,
      -25,
      this.a * 2,
      new Two.Stop(0, 'rgb(255, 255, 255)', null),
      new Two.Stop(1, 'rgb(0,0,0)', null),
    );
    this.rightEye.fill = this.two.makeRadialGradient(
      -10,
      -25,
      this.a * 2,
      new Two.Stop(0, 'rgb(255, 255, 255)', null),
      new Two.Stop(1, 'rgb(0,0,0)', null),
    );
  };

  private updateVerticesReverse = function (data) {
    this.data = data;
    let vertices = this.createPlotData(data, 'both');
    let calcs = this.performCalcs(vertices);

    let circ = calcs.circ.toFixed(2);
    this.c = circ;

    let center = calcs.center; //calculateGeometricCenter(vertices);
    let boundingBoxVertices = calcs.boundingBox; //createBoundingBox(vertices);
    let xOffset =
      (parseFloat(this.a) / 2) * this.scale + (parseFloat(this.dbl) / 2) * this.scale - center.x * this.scale;
    let yScale = ((data && data.angles) || []).length ? -1 : 1;

    this.leftEye.vertices = vertices;
    this.leftEye._matrix
      .identity()
      .translate(this.two.width / 2 + xOffset, this.two.height / 2 + center.y)
      .scale(this.scale, this.scale * yScale);

    // This is for adding a box around the lense.
    // this.leftEye.boundingBox.vertices = boundingBoxVertices;
    // this.leftEye.boundingBox._matrix.identity()
    // 																.translate((this.two.width / 2) - (xOffset), (this.two.height / 2) + center.y)
    // 																.scale(-1 * this.scale, this.scale * yScale);

    //This is for making the box a dashed line
    // if(this.leftEye.boundingBox._renderer.elem) {
    // this.leftEye.boundingBox._renderer.elem.setAttribute('stroke-dasharray', '2,2');
    // }

    this.rightEye.vertices = vertices;
    this.rightEye._matrix
      .identity()
      .translate(this.two.width / 2 - xOffset, this.two.height / 2 + center.y)
      .scale(-1 * this.scale, this.scale * yScale);

    // This is for adding a box around the lense.
    // this.rightEye.boundingBox.vertices = boundingBoxVertices;
    // this.rightEye.boundingBox._matrix.identity()
    // 																 .translate((this.two.width / 2) + xOffset, (this.two.height / 2) + center.y)
    // 																 .scale(this.scale, this.scale * yScale);

    //This is for making the box a dashed line
    // if(this.rightEye.boundingBox._renderer.elem) {
    // this.rightEye.boundingBox._renderer.elem.setAttribute('stroke-dasharray', '2,2');
    // }

    // This is for creating the DBL box
    // this.dblBox.vertices = createDBLBox(this.a, this.b, this.dbl);

    //This is for making the box a dashed line
    // if(this.dblBox._renderer.elem) {
    // this.dblBox._renderer.elem.setAttribute('stroke-dasharray', '2,2');
    // }

    let colors = [
      'rgb(255, 64, 64)',
      'rgb(255, 128, 0)',
      'rgb(0, 200, 255)',
      'rgb(0, 191, 168)',
      'rgb(153, 102, 255)',
      'rgb(255, 244, 95)',
    ];
    let grad = this.two.makeLinearGradient(
      10,
      10,
      -10,
      -10,
      new Two.Stop(0, colors[0], 0),
      new Two.Stop(1, colors[1], 0),
      new Two.Stop(1, colors[2], 0),
    );
    this.leftEye.fill = this.two.makeRadialGradient(
      10,
      -25,
      this.a * 2,
      new Two.Stop(0, 'rgb(255, 255, 255)', null),
      new Two.Stop(1, 'rgb(0,0,0)', null),
    );
    this.rightEye.fill = this.two.makeRadialGradient(
      -10,
      -25,
      this.a * 2,
      new Two.Stop(0, 'rgb(255, 255, 255)', null),
      new Two.Stop(1, 'rgb(0,0,0)', null),
    );
  };

  private updateRightVertices(data) {
    this.data = data;
    let vertices = this.createPlotData(data, 'right');
    let calcs = this.performCalcs(vertices);

    let circ = calcs.circ.toFixed(2);
    this.c = circ;

    let center = calcs.center; //calculateGeometricCenter(vertices);
    let boundingBoxVertices = calcs.boundingBox; //createBoundingBox(vertices);
    let xOffset =
      (parseFloat(this.a) / 2) * this.scale + (parseFloat(this.dbl) / 2) * this.scale - center.x * this.scale;
    let yScale = ((data && data.angles) || []).length ? -1 : 1;

    this.rightEye.vertices = vertices;
    this.rightEye._matrix
      .identity()
      .translate(this.two.width / 2 - xOffset, this.two.height / 2 + center.y)
      .scale(this.scale, this.scale * yScale);

    //I know it says left eye but it is technically drawing the right eye bounding box
    //This is for drawing a box around the lendse
    // this.leftEye.boundingBox.vertices = boundingBoxVertices;
    // this.leftEye.boundingBox._matrix.identity()
    // 																.translate((this.two.width / 2) - (xOffset), (this.two.height / 2) + center.y)
    // 																.scale(-1 * this.scale, this.scale * yScale);

    // This is for making the box, dashed.
    // if(this.leftEye.boundingBox._renderer.elem) {
    // 	this.leftEye.boundingBox._renderer.elem.setAttribute('stroke-dasharray', '2,2');
    // }

    let colors = [
      'rgb(255, 64, 64)',
      'rgb(255, 128, 0)',
      'rgb(0, 200, 255)',
      'rgb(0, 191, 168)',
      'rgb(153, 102, 255)',
      'rgb(255, 244, 95)',
    ];

    let grad = this.two.makeLinearGradient(
      10,
      10,
      -10,
      -10,
      new Two.Stop(0, colors[0], 0),
      new Two.Stop(1, colors[1], 0),
      new Two.Stop(1, colors[2], 0),
    );
    this.rightEye.fill = this.two.makeRadialGradient(
      -10,
      -25,
      this.a * 2,
      new Two.Stop(0, 'rgb(255, 255, 255)', null),
      new Two.Stop(1, 'rgb(0,0,0)', null),
    );
  }

  divide(arrNum) {
    let retArr = [];
    arrNum.forEach((element) => {
      retArr.push(parseFloat(element) / 1000);
    });

    return retArr;
  }
}
